import React from "react";

import { plans } from '../../contexts/FeatureGating';
import { PlanToggle } from "./PlanToggle";

export function FeatureToggle({
  feature,
  label,
}) {
  return (
    <div className="row">
      <div className="col-feature">
        {label}
      </div>
      <div className="col-plan">
        <PlanToggle plan={plans.FREEMIUM} feature={feature} />
      </div>
      <div className="col-plan">
        <PlanToggle plan={plans.CLUB} feature={feature} />
      </div>
      <div className="col-plan">
        <PlanToggle plan={plans.BLACK} feature={feature} />
      </div>
    </div>
  );
}
